import { parseSlug } from '@shared/utils';

export interface ConfigureSearchParamsOptions {
  artistId: string;
  configurationId: string;
  loadMore?: number;
  page: number;
  pageSize: number;
  slug: string;
  sortField?: string;
  sortOrder?: string;
}

export function configureSearchParams(options: ConfigureSearchParamsOptions): URLSearchParams {
  const parsedParams = parseSlug(options.slug);

  const preparedParams: Record<string, string> = {
    offset: `${options.pageSize * (options.page + (options.loadMore ?? 0) - 1)}`,
    limit: `${options.pageSize}`,
    institutions: options.configurationId,
    artists: `${options.artistId}`,
    ...parsedParams,
  };

  if (options.sortField && options.sortOrder) {
    preparedParams.column = options.sortField;
    preparedParams.order = options.sortOrder;
  }

  return new URLSearchParams(preparedParams);
}
